/* eslint-disable no-unused-vars */
import React from 'react';
import { Grouping } from './Grouping';
import { HeaderItem } from './HeaderItem';
import styled, { css } from 'styled-components';
import { Palette } from 'config';
import { colsWidth } from 'constants';
import { Each } from 'components';

export const TableHeader = ({
  HEADER_ROW_HEIGHT,
  STORAGE_KEY,
  currentRequestType$,
  originalTableData$,
  sortConfig$,
  hideAdvertiserGrouping,
  renderCols,
  isSamsungUser,
}) => {
  return (
    <TableRow>
      <TableHeaderBox width={colsWidth['apps']}>
        <Grouping
          HEADER_ROW_HEIGHT={HEADER_ROW_HEIGHT}
          STORAGE_KEY={STORAGE_KEY}
          currentRequestType$={currentRequestType$}
          originalTableData$={originalTableData$}
          hideAdvertiserGrouping={hideAdvertiserGrouping}
          isSamsungUser={isSamsungUser}
          sortConfig$={sortConfig$}
          width={colsWidth['apps']}
        />
      </TableHeaderBox>
      <Each
        of={renderCols}
        render={(column, index) => {
          return (
            <TableHeaderBox width={colsWidth[column.toLowerCase()]}>
              <HeaderItem
                column={column}
                HEADER_ROW_HEIGHT={HEADER_ROW_HEIGHT}
                sortConfig$={sortConfig$}
              />
            </TableHeaderBox>
          );
        }}
      />
      {/* empty col to fill the rest of space */}
      <TableHeaderBox>
        <HeaderItem HEADER_ROW_HEIGHT={HEADER_ROW_HEIGHT} sortConfig$={sortConfig$} />
      </TableHeaderBox>
    </TableRow>
  );
};

const TableRow = styled.tr`
  background: ${Palette.PrimaryGray._000};
`;

const TableHeaderBox = styled.th`
  max-width: ${({ width }) => `${width}`};
  padding: 0;
`;
